// This file is auto-generated by @hey-api/openapi-ts
import type { Client, Options as ClientOptions, TDataShape } from './client';
import { client } from './client.gen';
import type {
    AlternateDatesSearchData,
    AlternateDatesSearchErrors,
    AlternateDatesSearchResponses,
    AvailabilitySearchData,
    AvailabilitySearchErrors,
    AvailabilitySearchResponses,
    CancelQuoteData,
    CancelQuoteErrors,
    CancelQuoteResponses,
    CancelReservationData,
    CancelReservationErrors,
    CancelReservationResponses,
    ConvertQuoteData,
    ConvertQuoteErrors,
    ConvertQuoteResponses,
    CreateBookingData,
    CreateBookingErrors,
    CreateBookingResponses,
    CreateFerryQuoteData,
    CreateFerryQuoteErrors,
    CreateFerryQuoteResponses,
    EmailQuoteData,
    EmailQuoteErrors,
    EmailQuoteResponses,
    FetchBookingData,
    FetchBookingErrors,
    FetchBookingResponses,
    FindReservationData,
    FindReservationErrors,
    FindReservationResponses,
    GetCountriesData,
    GetCountriesErrors,
    GetCountriesResponses,
    GetFerryBookingData,
    GetFerryBookingErrors,
    GetFerryBookingResponses,
    GetFerryBookingsData,
    GetFerryBookingsErrors,
    GetFerryBookingsResponses,
    GetFerryOptionsData,
    GetFerryOptionsErrors,
    GetFerryOptionsResponses,
    GetFerryQuoteData,
    GetFerryQuoteErrors,
    GetFerryQuoteResponses,
    GetFerryRoutesData,
    GetFerryRoutesErrors,
    GetFerryRoutesResponses,
    GetFerrySailingsData,
    GetFerrySailingsErrors,
    GetFerrySailingsResponses,
    GetFerryStatusData,
    GetFerryStatusErrors,
    GetFerryStatusResponses,
    GetFerryTimetableData,
    GetFerryTimetableErrors,
    GetFerryTimetableResponses,
    GetFleetCategoriesData,
    GetFleetCategoriesErrors,
    GetFleetCategoriesResponses,
    GetFleetCategoryByCodeData,
    GetFleetCategoryByCodeErrors,
    GetFleetCategoryByCodeResponses,
    GetFleetTypeBySlugData,
    GetFleetTypeBySlugErrors,
    GetFleetTypeBySlugResponses,
    GetFleetTypesData,
    GetFleetTypesErrors,
    GetFleetTypesResponses,
    GetMinimumHirePeriodsData,
    GetMinimumHirePeriodsErrors,
    GetMinimumHirePeriodsResponses,
    GetOptionsData,
    GetOptionsErrors,
    GetOptionsResponses,
    GetRentalCatalogData,
    GetRentalCatalogErrors,
    GetRentalCatalogResponses,
    GetSiteByCodeData,
    GetSiteByCodeErrors,
    GetSiteByCodeResponses,
    ListHirePeriodsData,
    ListHirePeriodsErrors,
    ListHirePeriodsResponses,
    ListSitesData,
    ListSitesErrors,
    ListSitesResponses,
    TripInfoData,
    TripInfoErrors,
    TripInfoResponses,
    UpdateFerryQuoteData,
    UpdateFerryQuoteErrors,
    UpdateFerryQuoteResponses,
    UpdateQuoteData,
    UpdateQuoteErrors,
    UpdateQuoteResponses,
    UpdateReservationData,
    UpdateReservationErrors,
    UpdateReservationResponses,
    ValidateUpdateReservationData,
    ValidateUpdateReservationErrors,
    ValidateUpdateReservationResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get hire periods information
 */
export const listHirePeriods = <ThrowOnError extends boolean = false>(options?: Options<ListHirePeriodsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListHirePeriodsResponses, ListHirePeriodsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/hire-periods',
        ...options,
    });
};

/**
 * Get a list of countries
 */
export const getCountries = <ThrowOnError extends boolean = false>(options?: Options<GetCountriesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCountriesResponses, GetCountriesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/countries',
        ...options,
    });
};

/**
 * List current hire periods
 */
export const getMinimumHirePeriods = <ThrowOnError extends boolean = false>(options?: Options<GetMinimumHirePeriodsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMinimumHirePeriodsResponses, GetMinimumHirePeriodsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/data/minimum-hire-periods',
        ...options,
    });
};

/**
 * Get a list of fleet categories
 */
export const getFleetCategories = <ThrowOnError extends boolean = false>(options?: Options<GetFleetCategoriesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFleetCategoriesResponses, GetFleetCategoriesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/fleet-categories',
        ...options,
    });
};

/**
 * Get a list of fleet types
 */
export const getFleetTypes = <ThrowOnError extends boolean = false>(options?: Options<GetFleetTypesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFleetTypesResponses, GetFleetTypesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/fleet-types',
        ...options,
    });
};

/**
 * Create a new quote and email it to the hirer
 */
export const emailQuote = <ThrowOnError extends boolean = false>(options?: Options<EmailQuoteData, ThrowOnError>) => {
    return (options?.client ?? client).post<EmailQuoteResponses, EmailQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/quotes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });
};

/**
 * Get a list of rental products
 */
export const getRentalCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetRentalCatalogData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRentalCatalogResponses, GetRentalCatalogErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/rental-catalog',
        ...options,
    });
};

/**
 * Find your reservation
 */
export const findReservation = <ThrowOnError extends boolean = false>(options?: Options<FindReservationData, ThrowOnError>) => {
    return (options?.client ?? client).post<FindReservationResponses, FindReservationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations/find',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });
};

/**
 * Create a new booking
 */
export const createBooking = <ThrowOnError extends boolean = false>(options?: Options<CreateBookingData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateBookingResponses, CreateBookingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });
};

/**
 * Get branch information
 */
export const listSites = <ThrowOnError extends boolean = false>(options?: Options<ListSitesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSitesResponses, ListSitesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/sites',
        ...options,
    });
};

/**
 * Search for availability and pricing for alternative dates
 */
export const alternateDatesSearch = <ThrowOnError extends boolean = false>(options: Options<AlternateDatesSearchData, ThrowOnError>) => {
    return (options.client ?? client).get<AlternateDatesSearchResponses, AlternateDatesSearchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/trip/alternate-dates-search',
        ...options,
    });
};

/**
 * Search for availability and pricing
 */
export const availabilitySearch = <ThrowOnError extends boolean = false>(options: Options<AvailabilitySearchData, ThrowOnError>) => {
    return (options.client ?? client).get<AvailabilitySearchResponses, AvailabilitySearchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/trip/availability',
        ...options,
    });
};

/**
 * Get pricing, extras and insurance options for a trip
 */
export const tripInfo = <ThrowOnError extends boolean = false>(options: Options<TripInfoData, ThrowOnError>) => {
    return (options.client ?? client).get<TripInfoResponses, TripInfoErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/trip/info',
        ...options,
    });
};

/**
 * Get ferry options
 */
export const getFerryOptions = <ThrowOnError extends boolean = false>(options: Options<GetFerryOptionsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryOptionsResponses, GetFerryOptionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/options',
        ...options,
    });
};

/**
 * Get available ferry routes
 */
export const getFerryRoutes = <ThrowOnError extends boolean = false>(options: Options<GetFerryRoutesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryRoutesResponses, GetFerryRoutesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/routes',
        ...options,
    });
};

/**
 * Get available ferry sailings
 */
export const getFerrySailings = <ThrowOnError extends boolean = false>(options: Options<GetFerrySailingsData, ThrowOnError>) => {
    return (options.client ?? client).post<GetFerrySailingsResponses, GetFerrySailingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/sailings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};

/**
 * Get ferry status for given reservation
 */
export const getFerryStatus = <ThrowOnError extends boolean = false>(options: Options<GetFerryStatusData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryStatusResponses, GetFerryStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/status',
        ...options,
    });
};

/**
 * Get ferry timetable
 */
export const getFerryTimetable = <ThrowOnError extends boolean = false>(options: Options<GetFerryTimetableData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryTimetableResponses, GetFerryTimetableErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/timetable',
        ...options,
    });
};

/**
 * Get fleet category information
 */
export const getFleetCategoryByCode = <ThrowOnError extends boolean = false>(options: Options<GetFleetCategoryByCodeData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFleetCategoryByCodeResponses, GetFleetCategoryByCodeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/fleet-categories/{fleetCategoryCode}',
        ...options,
    });
};

/**
 * Get fleet type information
 */
export const getFleetTypeBySlug = <ThrowOnError extends boolean = false>(options: Options<GetFleetTypeBySlugData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFleetTypeBySlugResponses, GetFleetTypeBySlugErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/fleet-types/{fleetTypeSlug}',
        ...options,
    });
};

/**
 * Cancel an existing quote
 */
export const cancelQuote = <ThrowOnError extends boolean = false>(options: Options<CancelQuoteData, ThrowOnError>) => {
    return (options.client ?? client).delete<CancelQuoteResponses, CancelQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/quotes/{reservationRef}',
        ...options,
    });
};

/**
 * Convert a quote in to a reservation
 */
export const convertQuote = <ThrowOnError extends boolean = false>(options: Options<ConvertQuoteData, ThrowOnError>) => {
    return (options.client ?? client).get<ConvertQuoteResponses, ConvertQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/quotes/{reservationRef}/convert',
        ...options,
    });
};

/**
 * Make updates and edit an existing quote
 */
export const updateQuote = <ThrowOnError extends boolean = false>(options: Options<UpdateQuoteData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateQuoteResponses, UpdateQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/quotes/{reservationRef}/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};

/**
 * Cancel an existing reservation
 */
export const cancelReservation = <ThrowOnError extends boolean = false>(options: Options<CancelReservationData, ThrowOnError>) => {
    return (options.client ?? client).delete<CancelReservationResponses, CancelReservationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations/{reservationRef}',
        ...options,
    });
};

/**
 * Fetch a booking
 */
export const fetchBooking = <ThrowOnError extends boolean = false>(options: Options<FetchBookingData, ThrowOnError>) => {
    return (options.client ?? client).get<FetchBookingResponses, FetchBookingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations/{reservationRef}',
        ...options,
    });
};

/**
 * Make updates and edit an existing reservation
 */
export const updateReservation = <ThrowOnError extends boolean = false>(options: Options<UpdateReservationData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateReservationResponses, UpdateReservationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations/{reservationRef}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};

/**
 * Return options available for a booking
 */
export const getOptions = <ThrowOnError extends boolean = false>(options: Options<GetOptionsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetOptionsResponses, GetOptionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations/{reservationRef}/options',
        ...options,
    });
};

/**
 * Validate the update reservation
 */
export const validateUpdateReservation = <ThrowOnError extends boolean = false>(options: Options<ValidateUpdateReservationData, ThrowOnError>) => {
    return (options.client ?? client).post<ValidateUpdateReservationResponses, ValidateUpdateReservationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/reservations/{reservationRef}/validate-update-reservation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};

/**
 * Get branch information
 */
export const getSiteByCode = <ThrowOnError extends boolean = false>(options: Options<GetSiteByCodeData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSiteByCodeResponses, GetSiteByCodeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/sites/{siteCode}',
        ...options,
    });
};

/**
 * Get all ferry bookings for a given reservation
 */
export const getFerryBookings = <ThrowOnError extends boolean = false>(options: Options<GetFerryBookingsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryBookingsResponses, GetFerryBookingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/bookings',
        ...options,
    });
};

/**
 * Create ferry booking quote
 */
export const createFerryQuote = <ThrowOnError extends boolean = false>(options: Options<CreateFerryQuoteData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateFerryQuoteResponses, CreateFerryQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/quote',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};

/**
 * Get a ferry booking
 */
export const getFerryBooking = <ThrowOnError extends boolean = false>(options: Options<GetFerryBookingData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryBookingResponses, GetFerryBookingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/bookings/{bookingRef}',
        ...options,
    });
};

/**
 * Retrieve ferry booking quote
 */
export const getFerryQuote = <ThrowOnError extends boolean = false>(options: Options<GetFerryQuoteData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFerryQuoteResponses, GetFerryQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/quote/{bookingRef}',
        ...options,
    });
};

/**
 * Update ferry booking quote
 */
export const updateFerryQuote = <ThrowOnError extends boolean = false>(options: Options<UpdateFerryQuoteData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateFerryQuoteResponses, UpdateFerryQuoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http',
            },
            {
                name: 'X-API-KEY',
                type: 'apiKey',
            },
        ],
        url: '/api/v3/ferry/{reservationRef}/quote/{bookingRef}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
